<template>
  <div>
    <el-drawer v-loading="loading" title="不定价销售订单" :visible.sync="show" size="90%" :before-close="handleClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看'" :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row style="display: flex;flex-wrap: wrap;">
            <el-col :span="6">
              <el-form-item label="不定价销售单号">
                <el-input v-model="form.sn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SAP销售单号">
                <el-input v-model="form.sapOrderSn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据类型" prop="salesCode">
                <el-select v-model="form.salesCode" :disabled="isDisabled || isRejectTo" placeholder="请选择"
                  @change="changeSalesType">
                  <el-option v-for="item in salesTypeOptions" :key="item.code" :label="item.name" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="销售组织" prop="salesOrganizationId">
                <el-select v-model="form.salesOrganizationId" :disabled="isDisabled || isRejectTo" @change="
                    getOptionOrganization(form.salesOrganizationId)
                  ">
                  <el-option v-for="item in salesOrganizationOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="分销渠道" prop="channelOfDistributionId">
                <el-select v-model="form.channelOfDistributionId" :disabled="isDisabled || isRejectTo"
                  @change="getProductTeamOption(form.channelOfDistributionId)">
                  <el-option v-for="item in channelDistributioOption" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品组" prop="productTeamId">
                <el-select v-model="form.productTeamId" :disabled="isDisabled || isRejectTo">
                  <el-option v-for="item in productTeamOption" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务类型" prop="businessTypeId">
                <el-select v-model="form.businessTypeId" placeholder="请选择" :disabled="isRejectTo">
                  <el-option v-for="item in businessTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="售达方" prop="soldToPartyName">
                <el-input v-model="form.soldToPartyName" readonly :disabled="isRejectTo">
                  <el-button slot="append" :disabled="isRejectTo" icon="el-icon-search" style="background: white;"
                    @click="selectSoldToParty" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="送达方" prop="deliverySideName">
                <el-input v-model="form.deliverySideName" readonly :disabled="isRejectTo">
                  <el-button slot="append" :disabled="isRejectTo" icon="el-icon-search" style="background: white;"
                    @click="selectDeliverySide" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据状态" prop="status">
                <el-input v-model="statusArr[form.status]" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="交货工厂" prop="factoryId">
                <el-select v-model="form.factoryId" placeholder="请选择" :disabled="isRejectTo">
                  <el-option v-for="item in factoryOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中间公司" prop="middleCompanyId"
                :rules="form.isVatRetreat == 1 ? [{ required: true, message: '请选择中间公司', trigger: 'change' }] : []">
                <el-input v-model="form.middleCompanyName" readonly :disabled="isRejectTo">
                  <el-button slot="append" :disabled="isRejectTo" icon="el-icon-search" style="background: white;"
                    @click="selectMiddleCompany" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人">
                <el-input v-model="form.createUser" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间">
                <el-input v-model="form.createTime" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否已定价" prop="isPricingPrice">
                <el-select v-model="form.isPricingPrice" placeholder="请选择" disabled>
                  <el-option v-for="item in isPricingPriceOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <el-checkbox v-model="form.isVatRetreat" :true-label="1" :false-label="0">退征即退</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="价格状态" prop="priceStatus">
                <el-select v-model="form.priceStatus" placeholder="请选择" disabled>
                  <el-option v-for="item in priceStatusOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-model="form.note" placeholder="请输入" :disabled="isRejectTo" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据日期" prop="orderTime">
                <el-date-picker v-model="form.orderTime" :disabled="isRejectTo" type="date" placeholder="选择日期"
                  value-format="yyyy-MM-dd" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="跟单员" prop="orderFollower">
                <el-input v-model="form.orderFollower" readonly placeholder="请选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectOrderFollower" />
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="附件信息">
          <el-row>
            <FileUpload :file-type="['png', 'jpg', 'jpeg','doc','xls','pdf','xlsx','docx']"
              :value.sync="form.crmSalesIndeterminateAccessoryModels"
              :show-delect="form.status <= 1 || form.status==null" />
          </el-row>
        </el-card>
        <el-card header="订单明细">
          <el-tabs v-model="activePaneName">
            <!-- <el-tab-pane label="配件" name="mountings">
              <el-row>
                <el-col>
                  <el-button type="primary" @click="addMountingsLine()">新增一行</el-button>
                  <el-button type="danger" @click="delectMountingsLine()">一键清空配件列表</el-button>
                </el-col>
              </el-row>
              <el-table v-if="!showObj.mountings" ref="mountingsTable" :data="form.mountingsList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'mountingsList.' + scope.$index + '.qty'
                      "
                      :rules="mountingsList.qty"
                    >
                      <el-input v-model="scope.row.qty" placeholder="请输入" min="0" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'mountingsList.' + scope.$index + '.taxPrice'
                      "
                      :rules="mountingsList.taxPrice"
                    >
                      <el-input v-model="scope.row.taxPrice" placeholder="请输入" min="0" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="OE" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车辆ID" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carId">
                      <el-input v-model="scope.row.carId" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carNo">
                      <el-input v-model="scope.row.carNo" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="brand">
                      <el-input v-model="scope.row.brand" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车系" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="series">
                      <el-input v-model="scope.row.series" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="年款" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="modelYear">
                      <el-input v-model="scope.row.modelYear" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发动机型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="engineModel">
                      <el-input v-model="scope.row.engineModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="变速箱型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="transmissionModel">
                      <el-input v-model="scope.row.transmissionModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="排量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="displacement">
                      <el-input v-model="scope.row.displacement" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="handleMountingsDelete(scope.$index)"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
            <el-tab-pane label="废料" name="flotsam">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" :disabled="isRejectTo" @click="addFlotsamLine()">新增一行</el-button>
                <el-button type="danger" :disabled="isRejectTo" @click="delectFlotsamLine()">一键清空废料列表</el-button>
              </div>
              <el-table v-if="!showObj.flotsam" ref="flotsamTable" height="400px" :data="form.flotsamList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'flotsamList.' + scope.$index + '.qty'
                      " :rules="flotsamList.qty">
                      <el-input v-model="scope.row.qty" :disabled="isRejectTo" min="0" placeholder="请输入" type="number"
                        @blur="sumLordDutyPrice(scope.row,scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="市场价格" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="referencePrice">
                      <el-input v-model="scope.row.referencePrice" :disabled="true" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'flotsamList.' + scope.$index + '.taxPrice'
                      " :rules="flotsamList.taxPrice">
                      <el-input v-model="scope.row.taxPrice" :disabled="!(form.deliverType==2 && form.priceStatus==1)"
                        min="0" placeholder="请输入" type="number" @blur="sumLordDutyPrice(scope.row,scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税单价" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxExclusiveUnitPrice">
                      <el-input v-model="scope.row.taxExclusiveUnitPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="是否配件" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="isParts">
                      <el-select v-model="scope.row.isParts" placeholder="请选择">
                      <el-option
                        v-for="item in isPartsOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" :disabled="isRejectTo" />
                    </el-form-item>
                  </template>
                </el-table-column>
                 <el-table-column v-if="false" label="扣杂金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="deductionAmount">
                      <el-input v-model="scope.row.deductionAmount"  placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="产值差异原因" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lowPriceReason">
                      <el-select v-model="scope.row.lowPriceReason" placeholder="请选择" :disabled="!(form.deliverType==2 && form.priceStatus==1)">
                        <el-option v-for="item in lowPriceReasons" :key="item.value" :label="item.label"
                          :value="item.value" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="产值差异图片" align="left" show-overflow-tooltip width="260">
                  <template slot-scope="scope">
                    <el-form-item prop="fileList">
                      <UploadPicture :file-type="['png', 'jpg', 'jpeg']" :show-delect="true" :disabled="!(form.deliverType==2 && form.priceStatus==1)" :reference-id="scope.row.id"
                        :reference-table="'crm_sales_orders_line'" :attribute1="'扣杂凭证'"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button :disabled="isRejectTo" type="text"
                      @click="handleFlotsamDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <!-- 普通流程 -->
        <!--  v-if="form.status != 3 " -->
        <el-card v-if="form.deliverType<=1" header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName"
                      :value="item.id" />
                  </el-select>
                </el-form-item>

              </el-col>

            </el-row>
            <!-- <el-row>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="margin-bottom: 5px;"
                  @click="addNodePerson()"
                >新增审批人</el-button>
              </el-col>
            </el-row> -->

            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable"
              style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                    <!-- <el-input
                      v-model="scope.row.companyName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="
                      'flowPathNodePersonModels.' + scope.$index + '.nodePerson'
                    " :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search"
                        @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="deleteNodePerson(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>

          <!-- {{ form.flowId }} -->
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId"
            @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <!-- 价格流程审批 -->
        <el-card v-if="form.status == 3 && form.deliverType==2" header="价格流程审批">
          <div v-if="form.priceStatus <= 1 || form.priceStatus==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="priceFlowPathTemplateId">
                  <el-select v-model="form.priceFlowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName"
                      :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable"
              style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                    <!-- <el-input
                      v-model="scope.row.companyName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="
                      'flowPathNodePersonModels.' + scope.$index + '.nodePerson'
                    " :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search"
                        @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="deleteNodePerson(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <Flow ref="priceFlow" :disabled="type == '查看' || form.priceStatus > 2" :custom-event="true"
            :flow-id="form.priceFlowId" @flowLoad="flowLoadPrice" @complete="onCompletePrice" @refresh="flowRefresh"
            @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary"
            @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary"
            @click="saveAndSubmit()">提交</el-button>
          <el-button v-if="form.id && form.deliverType == 2 && form.priceStatus<=1" type="primary"
            @click="saveAndSubmitPrice()">价格审核提交</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 售达方 -->
    <el-dialog class="dialog" :title="'选择售达方'" :visible.sync="showObj.soldToParty" width="60%"
      :before-close="soldToPartyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.soldToParty.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getSoldToPartyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" class="selectNone" :data="dialog.soldToParty" border height="300"
        @selection-change="handleSoldToPartySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip />
        <!-- <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip />
        <el-table-column label="单据状态" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      -->
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.soldToParty.total" :page.sync="pagination.soldToParty.current"
          :limit.sync="pagination.soldToParty.size" @pagination="getSoldToPartyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="soldToPartyClose">取消</el-button>
        <el-button type="primary" @click="soldToPartyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 送达方 -->
    <el-dialog class="dialog" :title="'选择送达方'" :visible.sync="showObj.deliverySide" width="60%"
      :before-close="deliverySideClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.deliverySide.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getDeliverySideDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" class="selectNone" :data="dialog.deliverySide" border height="300"
        @selection-change="handleDeliverySideSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip />
        <!-- <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip />
        <el-table-column label="单据状态" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip /> -->
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.deliverySide.total" :page.sync="pagination.deliverySide.current"
          :limit.sync="pagination.deliverySide.size" @pagination="getDeliverySideDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliverySideClose">取消</el-button>
        <el-button type="primary" @click="deliverySideConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="30%"
      :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300"
        @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current"
          :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 中间公司 -->
    <el-dialog class="dialog" :title="'选择中间公司'" :visible.sync="showObj.middleCompany" width="60%"
      :before-close="middleCompanyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.middleCompany.customerApplyName" clearable placeholder="请输入销售客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getMiddleCompanyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.middleCompany" border height="300"
        @selection-change="handleMiddleCompanySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="销售组织编码" align="left" prop="salesOrganizationCode" show-overflow-tooltip width="120" />
        <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="销售客户" align="left" prop="customerApplyName" show-overflow-tooltip width="150" />
        <el-table-column label="采购组织编码" align="left" prop="purchasingOrganizationCode" show-overflow-tooltip
          width="120" />
        <el-table-column label="采购组织" align="left" prop="purchasingOrganizationName" show-overflow-tooltip
          width="150" />
        <el-table-column label="采购供应商" align="left" prop="supplierName" show-overflow-tooltip width="150" />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.middleCompany.total" :page.sync="pagination.middleCompany.current"
          :limit.sync="pagination.middleCompany.size" @pagination="getMiddleCompanyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="middleCompanyClose">取消</el-button>
        <el-button type="primary" @click="middleCompanyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品配料 -->
    <el-dialog class="dialog" title="产品配料" :visible.sync="showObj.mountings" width="70%" :before-close="mountingsClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.mountings" :data="dialog.mountings" border height="300"
        @selection-change="handleMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" width="150" prop="productCode" show-overflow-tooltip />
        <el-table-column label="OE" align="left" width="150" prop="oeCode" show-overflow-tooltip />
        <el-table-column label="批次号" align="left" width="150" prop="batch" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" width="150" prop="carId" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" width="150" prop="carNo" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <!-- <el-table-column
            label="燃料类型"
            align="left"
            prop="oeCode"
            show-overflow-tooltip
          /> -->
        <el-table-column label="发动机型号" align="left" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.mountings.total" :page.sync="pagination.mountings.current"
          :limit.sync="pagination.mountings.size" @pagination="getMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsClose">取消</el-button>
        <el-button type="primary" @click="mountingsConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品废料 -->
    <el-dialog class="dialog" title="产品废料" :visible.sync="showObj.flotsam" width="60%" :before-close="flotsamClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.flotsam" :data="dialog.flotsam" border height="300"
        @selection-change="handleFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.flotsam.total" :page.sync="pagination.flotsam.current"
          :limit.sync="pagination.flotsam.size" @pagination="getFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flotsamClose">取消</el-button>
        <el-button type="primary" @click="flotsamConfirm">确认</el-button>
      </span>
    </el-dialog>

    <!-- 选择跟单员 -->
    <el-dialog class="dialog" title="选择跟单员" :visible.sync="showObj.orderFollower" width="70%"
      :before-close="orderFollowerClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getOrderFollowerDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.orderFollower" :data="dialog.orderFollower" border height="300"
        @selection-change="handleOrderFollowerSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="订单名称" align="left" prop="name" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.orderFollower.total" :page.sync="pagination.orderFollower.current"
          :limit.sync="pagination.orderFollower.size" @pagination="getOrderFollowerDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderFollowerClose">取消</el-button>
        <el-button type="primary" @click="orderFollowerConfirm">确认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import FileUpload from '@/components/FileUpload/index'
import { getPage as getSalesOrganization } from '@/api/crm/base/salesOrganization'
import { getPage as getDistributionChannels } from '@/api/crm/base/distributionChannels'
import { get as getProductTeam } from '@/api/crm/base/distributionChannels'
import { getPage as getFactory } from '@/api/crm/base/factory'
import { getPage as getTaxRate } from '@/api/crm/base/taxRate'
import { getPagePopup as getMountingsApi } from '@/api/crm/product/fittings'
import { getPagePopup as getFlotsamApi } from '@/api/crm/product/scraps'
import { getByGeneralManager } from '@/api/crm/base/audit'
import { getBusinessType } from '@/api/crm/base/businessTypeDict'
import Pagination from '@/components/Pagination'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'
import { getEnumItems } from '@/utils/enum'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'
import {
  get,
  saveOrUpdate,
  priceModification,
  getByCustomerApply,
  getByMiddleCompany,
  submit,
  priceConfirmationSubmit
} from '@/api/crm/order/unpricedOrder'
import { getFollowerApi, getCommonList } from '@/api/crm/order/salesOrder'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
import UploadPicture from '@/views/crm/order/salesOrder/uploadPicture.vue'
export default {
  name: 'UnpricedOrderEdit',
  components: {
    Pagination,
    FileUpload,
    Flow,
    UploadPicture
  },
  filters: {
    operateCategoryFilters(e) {
      const arr = e.split(',')
      const arr1 = getEnumItems('Crm_Business_Category')
      const arr2 = []
      for (const item of arr) {
        for (const v of arr1) {
          if (v.code === item) {
            arr2.push(v.name)
          }
        }
      }
      console.log(arr2.join())
      return arr2.join()
    }
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      companyOptions: [],
      salesOrganizationOptions: [],
      channelDistributioOption: [],
      productTeamOption: [],
      businessTypeOptions: [],
      factoryOptions: [],
      flowPathOptions: [],
      isPartsOptions: [{ value: 0, label: '否' }, { value: 1, label: '是' }],
      lowPriceReasons: [{ value: 1, label: '质量问题扣杂' }, { value: 2, label: '公式价偏高' }],
      priceStatusOptions: [
        {
          label: '价格待确认',
          value: 1
        },
        {
          label: '价格确认审核中',
          value: 2
        },
        {
          label: '价格确认审核完成',
          value: 3
        }
      ], //   1.价格待确认 2.价格确认审核中 3.价格确认审核完成
      isPricingPriceOptions: [
        {
          label: '否',
          value: 1
        },
        {
          label: '是',
          value: 2
        }
      ],
      format: format,
      areaData: [],
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        orderTime: format.formatDate(new Date(), 'yyyy-MM-dd'),
        isPricingPrice: 1,
        flotsamList: [],
        mountingsList: [],
        isVatRetreat: 0,
        salesOrganizationId: null,
        channelOfDistributionId: null,
        productTeamId: null,
        salesCode: null,
        flowPathNodePersonModels: [],
        soldToPartyName: null,
        orderFollower: null,
        flowPathTemplateId: null,
        roleId: null,
        priceFlowPathTemplateId: null,
        deliverType: null,
        crmSalesIndeterminateAccessoryModels: []
      },
      statusArr: ['', '制单', '审核中', '审核完成'],
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      mountingsList: {
        qty: [
          { required: true, message: '配件订单数量不能为空', trigger: 'blur' }
        ],
        taxPrice: [
          { required: true, message: '配件含税单价不能为空', trigger: 'blur' }
        ]
      },
      flotsamList: {
        qty: [
          { required: true, message: '废料订单数量不能为空', trigger: 'blur' }
        ],
        taxPrice: [
          { required: false, message: '废料含税单价不能为空', trigger: 'blur' }
        ]
      },
      rules: {
        salesCode: [
          { required: true, message: '单据类型不能为空', trigger: 'change' }
        ],
        salesOrganizationId: [
          { required: true, message: '销售组织不能为空', trigger: 'change' }
        ],
        channelOfDistributionId: [
          { required: true, message: '分销渠道不能为空', trigger: 'change' }
        ],
        productTeamId: [
          { required: true, message: '产品组不能为空', trigger: 'change' }
        ],
        soldToPartyName: [
          { required: true, message: '售达方不能为空', trigger: 'change' }
        ],
        factoryId: [
          { required: true, message: '交货工厂不能为空', trigger: 'change' }
        ],
        orderTime: [
          { required: true, message: '单据日期不能为空', trigger: 'change' }
        ],
        orderFollower: [
          { required: true, message: '跟单员不能为空', trigger: 'change' }
        ]
      },
      clientClassOptions: [],
      salesTypeOptions: getEnumItems('hlCrmSalesType'),
      activePaneName: 'flotsam',
      showObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        flotsam: false,
        orderFollower: false,
        nodePerson: false
      },
      loadingObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        flotsam: false,
        orderFollower: false,
        nodePerson: false
      },
      // 分页
      pagination: {
        mountings: {
          total: 0,
          size: 20,
          current: 1
        },
        soldToParty: {
          total: 0,
          size: 20,
          current: 1
        },
        deliverySide: {
          total: 0,
          size: 20,
          current: 1
        },
        middleCompany: {
          total: 0,
          size: 20,
          current: 1
        },
        orderFollower: {
          total: 0,
          size: 20,
          current: 1
        },
        flotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        flotsam: [],
        nodePerson: []
      },
      condition: {
        mountings: {},
        soldToParty: {},
        deliverySide: {},
        middleCompany: {},
        flotsam: {},
        orderFollower: {},
        nodePerson: {}
      },
      selection: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        flotsam: [],
        orderFollower: [],
        nodePerson: []
      },
      isDisabled: false,
      isRejectTo: false
      // { lordDutyPrice: null, taxRatio: null, taxlessPrice: null }
      // mountingsList: [],
      // flotsamList: []
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }
      this.init()
      this.flowPathNodePersonModels.nodePerson[0].required = false
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    },
    'form.mountingsList': {
      handler(val) {
        this.judegIsDisabled()
      }
    },
    'form.flotsamList': {
      handler(val) {
        this.judegIsDisabled()
      }
    }
  },
  methods: {
    init() {
      getSalesOrganization({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.salesOrganizationOptions = records.map((item) => {
          return {
            label: item.salesOrganizationName,
            value: item.id
          }
        })
      })
      getFactory({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.factoryOptions = records.map((item) => {
          return {
            label: item.factoryNumber + '-' + item.factoryName,
            value: item.id
          }
        })
      })
      this.getByPathTemplateApi()
      this.salesTypeOptions = getEnumItems('hlCrmSalesType')
      this.salesTypeOptions = this.salesTypeOptions.filter((item) => item.code == 'ZOR1')

      console.log(this.form.orderTime, this.salesTypeOptions, 'salesTypeOptionssalesTypeOptions')
    },
    getByPathTemplateApi() {
      console.log(1)
      let templateType = ''
      if (this.form.deliverType >= 2) {
        templateType = '不定价订单价格确认'
      } else {
        templateType = '不定价销售订单'
      }

      getByPathTemplate({ templateType }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
        console.log(this.flowPathOptions)
      })
    },
    // 基础数据
    changeSalesType(e) {
      const i = this.salesTypeOptions.findIndex((item) => item.code === e)
      if (i >= 0) {
        this.form.salesName = this.salesTypeOptions[i].name
      }
    },
    getOptionOrganization(id) {
      this.getChannelDistributioOption(id)
      this.getOptionOrganizationTaxRate(id)
      this.getBusinessTypeOption(id)
    },
    getBusinessTypeOption(id) {
      getBusinessType({ salesOrganizationId: id }, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.businessTypeOptions = records.map((item) => {
          return {
            label: item.salesOfficeCode + '-' + item.salesOfficeName,
            value: item.id
          }
        })
      })
    },
    async getOptionOrganizationTaxRate(id) {
      const { data } = await getTaxRate({ salesOrganizationId: id }, {
        total: 0,
        size: 20,
        current: 1
      })
      this.taxRatio = data.records[0].taxRatio
      this.calculation()
    },

    // 获取分销渠道
    async getChannelDistributioOption(id) {
      const { data } = await getDistributionChannels(
        { id },
        { current: 1, size: 1000 }
      )
      this.channelDistributioOption = data.records.map((item) => {
        return {
          label: item.channelDistributioName,
          value: item.id + ''
        }
      })
    },
    // 获取产品组
    async getProductTeamOption(id) {
      this.form.productTeamId = ''
      console.log(this.form.productTeamId)

      const { data } = await getProductTeam(id)
      this.productTeamOption = data.productTeamList.map((item) => {
        return {
          label: item.productTeamName,
          value: item.id + ''
        }
      })
      // return this.productTeamOption
    },
    // 售达方
    selectSoldToParty() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.soldToParty = true
      this.getSoldToPartyDialog()
    },
    async getSoldToPartyDialog() {
      this.loadingObj.soldToParty = true
      const data = {
        condition: {
          salesOrganizationId: this.form.salesOrganizationId,
          status: 3,
          customerApplyName: this.condition.soldToParty.customerApplyName,
          notBlacklist: 2
        },
        pagination: this.pagination.soldToParty
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.soldToParty = records
      this.pagination.soldToParty.total = total
      this.pagination.soldToParty.current = current
      this.pagination.soldToParty.size = size
      this.loadingObj.soldToParty = false
    },

    handleSoldToPartySelectionChange(val) {
      this.selection.soldToParty = val
    },
    soldToPartyConfirm() {
      if (this.selection.soldToParty.length > 1) {
        this.$message.warning('只能选择一位售达方！')
      } else {
        this.showObj.soldToParty = false
        console.log(this.selection.soldToParty)
        this.form.soldToPartyId = this.selection.soldToParty[0].id
        this.form.soldToPartyName = this.selection.soldToParty[0].customerApplyName
      }
    },
    soldToPartyClose() {
      this.showObj.soldToParty = false
    },
    // 送达方
    selectDeliverySide() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.deliverySide = true
      this.getDeliverySideDialog()
    },
    async getDeliverySideDialog() {
      this.loadingObj.deliverySide = true
      const data = {
        condition: {
          salesOrganizationId: this.form.salesOrganizationId,
          status: 3,
          customerApplyName: this.condition.deliverySide.customerApplyName,
          notBlacklist: 2
        },
        pagination: this.pagination.deliverySide
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.deliverySide = records
      this.pagination.deliverySide.total = total
      this.pagination.deliverySide.current = current
      this.pagination.deliverySide.size = size
      this.loadingObj.deliverySide = false
    },

    handleDeliverySideSelectionChange(val) {
      this.selection.deliverySide = val
    },
    deliverySideConfirm() {
      if (this.selection.deliverySide.length > 1) {
        this.$message.warning('只能选择一位送达方！')
      } else {
        this.showObj.deliverySide = false
        console.log(this.selection.deliverySide)
        this.form.deliverySideId = this.selection.deliverySide[0].id
        this.form.deliverySideName = this.selection.deliverySide[0].customerApplyName
      }
    },
    deliverySideClose() {
      this.showObj.deliverySide = false
    },
    // 审批人
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId
      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    // addNodePerson() {
    //   if (this.form.flowPathNodePersonModels === null) {
    //     this.form.flowPathNodePersonModels = []
    //   }
    //   this.form.flowPathNodePersonModels.push({})
    // },
    // deleteNodePerson(index) {
    //   this.form.flowPathNodePersonModels.splice(index, 1)
    // },
    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },

    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },
    // 中间公司
    selectMiddleCompany() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.middleCompany = true
      this.getMiddleCompanyDialog()
    },
    async getMiddleCompanyDialog() {
      this.loadingObj.middleCompany = true
      const data = {
        customerApplyName: this.condition.middleCompany.customerApplyName,
        salesOrganizationId: this.form.salesOrganizationId,
        pagination: this.pagination.middleCompany
      }
      const reponse = await getByMiddleCompany(data)
      const { current, total, size, records } = reponse.data
      this.dialog.middleCompany = records
      this.pagination.middleCompany.total = total
      this.pagination.middleCompany.current = current
      this.pagination.middleCompany.size = size
      this.loadingObj.middleCompany = false
    },

    handleMiddleCompanySelectionChange(val) {
      this.selection.middleCompany = val
    },
    middleCompanyConfirm() {
      if (this.selection.middleCompany.length > 1) {
        this.$message.warning('只能选择一个中间公司！')
      } else {
        this.showObj.middleCompany = false
        console.log(this.selection.middleCompany)
        this.form.middleCompanyId = this.selection.middleCompany[0].id
        this.form.middleCompanyName = this.selection.middleCompany[0].customerApplyName
      }
    },
    middleCompanyClose() {
      this.showObj.middleCompany = false
    },

    // 配件
    addMountingsLine() {
      if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
        this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
        return
      }
      this.showObj.mountings = true
      this.getMountings()
    },
    delectMountingsLine() {
      this.form.mountingsList = []
    },
    async getMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      const reponse = await getMountingsApi(this.condition.mountings, this.pagination.mountings)
      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    handleMountingsDelete(index) {
      this.form.mountingsList.splice(index, 1)
    },
    handleMountingsChange(val) {
      this.selection.mountings = val
    },
    mountingsConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      if (arr !== null && arr.length > 0) {
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
      } else {
        this.form.mountingsList = this.selection.mountings
      }
      for (const item of this.form.mountingsList) {
        item.productType = 1
        // item.isParts=0
      }
      if (this.taxRatio) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
        })
      }
      this.showObj.mountings = false
    },
    mountingsClose() {
      this.showObj.mountings = false
    },
    // 废料
    addFlotsamLine() {
      if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
        this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
        return
      }
      this.showObj.flotsam = true
      this.getFlotsam()
    },
    delectFlotsamLine() {
      this.form.flotsam = []
    },
    async getFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.flotsam.current = 1
      }
      this.loadingObj.flotsam = true
      const reponse = await getFlotsamApi(this.condition.flotsam, this.pagination.flotsam)
      const { current, total, size, records } = reponse.data
      this.dialog.flotsam = records
      this.pagination.flotsam.total = total
      this.pagination.flotsam.current = current
      this.pagination.flotsam.size = size
      this.loadingObj.flotsam = false
    },
    handleFlotsamDelete(index) {
      this.form.flotsamList.splice(index, 1)
    },
    handleFlotsamChange(val) {
      this.selection.flotsam = val
    },
    flotsamConfirm() {
      // this.selection.flotsam.forEach((item) => item.id = '')
      // console.log('进来了', this.selection.flotsam)
      const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
      if (arr !== null && arr.length > 0) {
        this.form.flotsamList = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode', 'batch')
      } else {
        this.form.flotsamList = this.selection.flotsam
      }
      for (const item of this.form.flotsamList) {
        item.productType = 2
        item.deductionAmount = 0
        // item.isParts=0
      }
      if (this.taxRatio) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
        })
      }
      console.log(this.form.flotsamList)
      this.showObj.flotsam = false
    },
    flotsamClose() {
      this.showObj.flotsam = false
    },
    // 判断有订单明细就给基础选项上锁
    judegIsDisabled() {
      if (this.form.flotsamList.length > 0 || this.form.mountingsList.length > 0) {
        this.isDisabled = true
      }
      if (this.form.flotsamList.length <= 0 && this.form.mountingsList.length <= 0) {
        this.isDisabled = false
      }
    },
    // 计算金额
    calculation() {
      if (this.form.mountingsList.length > 0) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
          if (item.lordDutyPrice) {
            this.$set(this.form.mountingsList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, this.taxRatio))
          }
        })
      }
      if (this.form.flotsamList.length > 0) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
          if (item.lordDutyPrice) {
            this.$set(this.form.flotsamList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, this.taxRatio))
          }
        })
      }
    },
    inclusiveAmount(qty, taxPrice) {
      const num = qty * taxPrice
      if (num.toString().split('.')[1] && num.toString().split('.')[1].length > 6) {
        return num.toFixed(6)
      } else {
        return num
      }
    },
    amountExcludingTax(lordDutyPrice, taxRatio) {
      const num = lordDutyPrice / (1 + taxRatio / 100)
      if (num.toString().split('.')[1] && num.toString().split('.')[1].length > 6) {
        return num.toFixed(6)
      } else {
        return num
      }
    },
    sumLordDutyPrice(item, index, type = '') {
      if (item.qty && item.taxPrice) {
        if (type === 'mountings') {
          this.$set(this.form.mountingsList[index], 'lordDutyPrice', this.inclusiveAmount(item.qty, item.taxPrice))
          this.sumTaxlessPrice(item, index, 'mountings')
        } else {
          this.$set(this.form.flotsamList[index], 'lordDutyPrice', this.inclusiveAmount(item.qty, item.taxPrice))
          this.sumTaxlessPrice(item, index)
        }
      }
    },
    sumTaxlessPrice(item, index, type = '') {
      if (item.lordDutyPrice && item.taxRatio) {
        if (type === 'mountings') {
          this.$set(this.form.mountingsList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, item.taxRatio))
        } else {
          this.$set(this.form.flotsamList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, item.taxRatio))
        }
      }
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        this.getByPathTemplateApi()
        this.$set(this.form, 'mountingsList', [])
        this.$set(this.form, 'flotsamList', [])
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId
        if (this.form.crmSalesIndeterminateOrderLineModels && this.form.crmSalesIndeterminateOrderLineModels.length > 0) {
          for (const item of this.form.crmSalesIndeterminateOrderLineModels) {
            if (item.productType === 1) {
              this.form.mountingsList.push(item)
            } else {
              this.form.flotsamList.push(item)
            }
          }
        }
        this.form.channelOfDistributionId =
          this.form.channelOfDistributionId?.toString()
        const productTeamId = this.form.productTeamId?.toString()

        this.getOptionOrganization(this.form.salesOrganizationId)
        this.getProductTeamOption(this.form.channelOfDistributionId)
        this.form.productTeamId = productTeamId
        console.log(this.form.productTeamId)
        // this.form.mountingsList = []
        // this.form.flotsamList = []
        console.log(123123123)
        if (this.form.deliverType == 2) {
          console.log(this.form.deliverType, true)
          this.flotsamList.taxPrice[0].required = true
        } else {
          console.log(this.form.deliverType, false)

          this.flotsamList.taxPrice[0].required = false
        }
        this.flowRejectTo(null, null)
        this.loading = false
        // this.$nextTick(() => {
        //   this.$refs.elTable.doLayout()
        // })
      } catch (error) {
        this.loading = false
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true

            const formData = JSON.parse(JSON.stringify(this.form))
            // 没有送达方就赋值成售达方
            if (!formData.deliverySideId) {
              formData.deliverySideId = formData.soldToPartyId
              formData.deliverySideName = formData.soldToPartyName
            }
            formData.crmSalesIndeterminateOrderLineModels = formData.mountingsList.concat(formData.flotsamList)
            if (formData.crmSalesIndeterminateOrderLineModels.length <= 0) {
              this.$message.warning('订单明细不能为空')
              this.loading = false
              return
            }
            delete formData.mountingsList
            delete formData.flotsamList
            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            this.editId = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    //  选择跟单员
    selectOrderFollower() {
      this.showObj.orderFollower = true
      this.getOrderFollowerDialog()
    },
    async getOrderFollowerDialog(type = '') {
      if (type === 'refresh') {
        this.pagination.orderFollower.current = 1
      }
      this.loadingObj.orderFollower = true
      this.condition.orderFollower
      const { data } = await getFollowerApi({ condition: this.condition.orderFollower, pagination: this.pagination.orderFollower })

      this.dialog.orderFollower = data?.records || []
      this.pagination.orderFollower.total = data?.total || 0
      this.pagination.orderFollower.current = data?.current || 1
      this.pagination.orderFollower.size = data?.size || 20
      this.loadingObj.orderFollower = false
    },
    handleOrderFollowerSelectionChange(val) {
      this.selection.orderFollower = val
    },
    orderFollowerConfirm() {
      if (this.selection.orderFollower.length > 1) {
        this.$message.warning('只能选择一个跟单员！')
      } else {
        console.log(this.selection.orderFollower)
        this.form.orderFollower = this.selection.orderFollower[0].name
        this.$refs.form.validateField('orderFollower')
        this.orderFollowerClose()
      }
    },
    orderFollowerClose() {
      this.showObj.orderFollower = false
    },
    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 普通流程 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    },
    // 确认价格流程 保存并提交
    async saveAndSubmitPrice() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.priceFlowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitPriceModification('form', false, async () => {
        await this.submitPrice()
      })
    },
    // 确认价格流程提交
    async onCompletePrice() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.priceFlowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitPriceModification('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.priceFlow.onComplete()
        this.handleClose()
      })
    },
    flowLoadPrice(e) {
      this.flowOptions = e
      this.$refs.priceFlow.validatorForm.push(this.$refs.isProceeds)
    },
    flowRejectTo(isAssignee, nodeName) {
      console.log(isAssignee && nodeName)
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        if (this.form.status > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    async submitPrice() {
      try {
        this.loading = true
        const response = await priceConfirmationSubmit(this.form.id)
        this.form.priceFlowId = response.data
        this.loading = false
        // this.handleClose()
        this.getData()
      } catch (error) {
        this.loading = false
      }
    },
    // 价格确认流程用这个接口
    async submitPriceModification(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        // return
        if (valid) {
          console.log(valid)
          console.log(this.form)

          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true

            const formData = JSON.parse(JSON.stringify(this.form))
            // 没有送达方就赋值成售达方
            if (!formData.deliverySideId) {
              formData.deliverySideId = formData.soldToPartyId
              formData.deliverySideName = formData.soldToPartyName
            }
            formData.crmSalesIndeterminateOrderLineModels = formData.mountingsList.concat(formData.flotsamList)
            if (formData.crmSalesIndeterminateOrderLineModels.length <= 0) {
              this.$message.warning('订单明细不能为空')
              this.loading = false
              return
            }
            delete formData.mountingsList
            delete formData.flotsamList
            const { message, data } = await priceModification(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    async submit() {
      try {
        // if(this.form.salesName === '废料销售订单') {
        //   for (const item of this.form.flotsamList) {
        //     if (item.referencePrice < item.taxPrice && !item.lowPriceReason ) {
        //       this.$message({
        //         type: 'warning',
        //         message: '废料销售价格低于市场价格，需要选择产值差异原因'
        //       })
        //       return
        //     } else if(item.referencePrice < item.taxPrice && item.lowPriceReason === 1 ) {
        //       let queryInfo = {
        //         referenceTable: 'crm_sales_orders_line ',
        //         attribute1: '扣杂凭证',  
        //         intReferenceId: item.id,
        //       }
        //       const { code, data } = await getCommonList(queryInfo)
        //       if(code == 200) {
        //         console.log("进入方法")
        //         if(!data || data.length <= 0) {
        //           this.$message({
        //             type: 'warning',
        //             message: '需要上传质量问题扣杂图片'
        //           })
        //           return;
        //         }
        //       } else {
        //         return;
        //       }
        //     }
        //   }
        // }
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        this.loading = false
        // this.handleClose()
        this.getData()
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>
    <style scoped>
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
.selectNone {
  user-select: none;
}
</style>

